import { TABS } from "./interfaces"

export const TAB_NAMES: Record<TABS, string> = {
    [TABS.CALENDAR]: "Расписание",
    [TABS.CLIENTS]: "Клиенты",
    [TABS.CLIENTS_FEEDBACK]: "Обратная связь",
    [TABS.PAYMENTS]: "Отчеты",
}

export const TAB_PATHS: Record<TABS, string> = {
    [TABS.CALENDAR]: "/calendar",
    [TABS.CLIENTS]: "/clients",
    [TABS.CLIENTS_FEEDBACK]: "/clients/feedback",
    [TABS.PAYMENTS]: "/payouts",
}

export const FEEDBACK_URL = "/clients/feedback"
